export const REVIEW_SELECTION = `
    id
    status
    type
    comment
    rating
    shop {
        id
        name
    }
    booking {
        id
        displayName
        status
    }
    populatedUser {
        id
        name
    }
    createdAt
`;

// user {
//     id
//     name
// }
export const REVIEW_STATS_SELECTION = `
    total
    byPoints {
        BAD
        MEDIUM
        GOOD
        EXCELLENCE
    }
`;
